import { useTheme, useWindowProperties } from '@qred/components-library';
import React from 'react';
import { useSelector } from 'react-redux';
import { ConfirmationCard } from '~/components/shared/ConfirmationCard/ConfirmationCard';
import { getHomePageByMarket } from '~/constants/markets';
import useTranslate from '~/hooks/useTranslate';
import { isInIframe } from '~/iframeMode';
import { RootState } from '~/store';
import {
  GoldenRatioContainer,
  StandardPageContainer,
} from '~/styles/BaseStyledComponents';

export const ConfirmationPage = () => {
  const t = useTranslate();
  const { market, language } = useSelector((state: RootState) => state.intl);
  const { isMobile } = useWindowProperties();
  const theme = useTheme();

  const onClickGoToWebsite = () => {
    window.location.assign(getHomePageByMarket(market, language));
  };

  return (
    <StandardPageContainer
      data-testid="card_application_confirmation_page"
      $isInIframe={isInIframe}
      $background={
        isInIframe ? undefined : theme.fn.themeColor('Page/Option_2_(Green)')
      }
    >
      <GoldenRatioContainer $grow={isMobile}>
        {isInIframe ? (
          <ConfirmationCard
            header={t('CardApplication.ConfirmationTitle') as string}
            text={t('CardApplication.ConfirmationDescription') as string}
          />
        ) : (
          <ConfirmationCard
            header={t('CardApplication.ConfirmationTitle') as string}
            text={t('CardApplication.ConfirmationDescription') as string}
            buttonText={t('Onboarding.GoToQredWebsite') as string}
            onButtonClick={onClickGoToWebsite}
          />
        )}
      </GoldenRatioContainer>
    </StandardPageContainer>
  );
};
